module.exports = __webpack_public_path__ + "fonts/fa-brands-400.c1868c95.eot";